import { render, staticRenderFns } from "./PostWriter.vue?vue&type=template&id=37378599&"
import script from "./PostWriter.vue?vue&type=script&lang=ts&"
export * from "./PostWriter.vue?vue&type=script&lang=ts&"
import style0 from "./PostWriter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports